import { InteractiveChartsView } from '../features/InteractiveChartsView';
import { ReportChartsView } from '../features/report/ReportChartsView';
import { SeparateWindowChartsView } from '../features/SeparateWindowChartsView';
import { ViewerMode } from '../App';

type ChartsPageProps = {
  mode: ViewerMode;
};

export const ChartsPage: React.FC<ChartsPageProps> = ({ mode }) => {
  if (mode === 'report') {
    return <ReportChartsView />;
  }

  if (mode === 'standalone') {
    return <SeparateWindowChartsView />;
  }

  return <InteractiveChartsView />;
};
